import { Box, Stack } from "@mui/material";
import React, { Fragment } from "react";
import ChannelCard from "./Cards/ChannelCard";
import VideoCard from "./Cards/VideoCard";

const Videos = ({ videos, direction }) => {
  if (!videos) {
    return;
  }
  const videoCard = videos.map((item, index) => {
    if (item.id.videoId) {
      return (
        <Box key={item.id.videoId}>
          {<VideoCard id={item.id.videoId} snippet={item.snippet} />}
        </Box>
      );
    }

    if (item.id.channelId) {
      return (
        <Box key={item.id.channelId}>
          {<ChannelCard id={item.id.channelId} snippet={item.snippet} />}
        </Box>
      );
    }
  });

  return (
    <Stack
      direction={direction || "row"}
      flexWrap="wrap"
      justifyContent="start"
      alignItems="start"
      gap={2}
    >
      {videoCard}
    </Stack>
  );
};

export default Videos;
